export const COLUMNS_COUNT = [2, 3] as const;
